import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsVotesBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Votes</div>
          <div className="text">
            Users can vote on posts. Admins can also vote on behalf of users. Vote objects are
            always associated with a post and a voter. The API allows you to fetch a specific vote,
            or a list of votes associated with a&nbsp;post.
          </div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
